export default __webpack_public_path__ + "static/media/XL.46501f74.png";